import script from "./my-cascaders.vue?vue&type=script&setup=true&lang=js"
export * from "./my-cascaders.vue?vue&type=script&setup=true&lang=js"

import "./my-cascaders.vue?vue&type=style&index=0&id=e3c042f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3c042f6"]])

export default __exports__